// Returns true if a sessionId exists in the sessionStorage
export const sessionIdExists = () => {
  return window.sessionStorage.getItem("sessionId") !== null;
};
